/* eslint-disable menti-react/filename-convention--jsx */
import * as React from 'react';
import {
  AccessibilityIcon,
  EyeIcon,
  type IconT,
} from '@mentimeter/ragnar-visuals';
import {
  AdminIcon,
  AlertIcon,
  PlaySolidIcon,
  StarSolidIcon,
} from '@mentimeter/ragnar-visuals';
import { useTranslations } from 'use-intl';
import { Box } from '../box';
import type { BadgeTypes } from './badge.types';

export const useBadgeMap = () => {
  const t = useTranslations('ragnar.badge');

  const BADGE_MAP: {
    [key in BadgeTypes]: {
      title: React.FC<IconT> | string;
      description?: string;
    };
  } = {
    basic: {
      title: t('badge_basic_title'),
    },
    pro: {
      title: t('badge_pro_title'),
    },
    'pro-multi': {
      title: t('badge_pro_multi_title'),
    },
    enterprise: {
      title: t('badge_enterprise_title'),
    },
    new: {
      title: t('badge_new_title'),
    },
    beta: {
      title: t('badge_beta_title'),
    },
    upgrade: {
      title: (props) => (
        <StarSolidIcon
          aria-label={t('badge_upgrade_title_a11y')}
          size={1}
          {...props}
        />
      ),
    },
    shared: {
      title: t('badge_shared_title'),
      description: t('badge_shared_description'),
    },
    template: {
      title: t('badge_template_title'),
      description: t('badge_template_description'),
    },
    example: {
      title: t('badge_example_title'),
      description: t('badge_example_description'),
    },
    team: {
      title: t('badge_team_title'),
    },
    admin: {
      title: (props) => (
        <AdminIcon
          aria-label={t('badge_admin_title_a11y')}
          size={1}
          {...props}
        />
      ),
    },
    soon: {
      title: t('badge_soon_title'),
    },
    text: {
      title: '',
    },
    'view-only': {
      title: t('badge_view_only_title'),
    },
    'view-only-icon': {
      title: (props) => (
        <EyeIcon
          aria-label={t('badge_view_only_title_a11y')}
          size={1}
          {...props}
        />
      ),
    },
    archived: {
      title: t('badge_archived_title'),
    },
    '50-licenses': {
      title: t('badge_50_licenses_title'),
    },
    warning: {
      title: (props) => (
        <AlertIcon
          aria-label={t('badge_warning_title_a11y')}
          size={1}
          {...props}
        />
      ),
    },
    play: {
      title: (props) => (
        <Box className="scale-[0.8] translate-x-px">
          <PlaySolidIcon aria-label={t('badge_play_title_a11y')} {...props} />
        </Box>
      ),
    },
    'published-template': {
      title: t('badge_published_template_title'),
    },
    premium: {
      title: t('badge_premium_title'),
    },
    free: {
      title: t('badge_free_title'),
    },
    accessibility: {
      title: (props) => (
        <AccessibilityIcon
          aria-label={t('badge_accessibility_title')}
          size={1}
          {...props}
        />
      ),
    },
  };

  return BADGE_MAP;
};
